import './App.css';
import './styles/owner-glass-dashboard.css';
import './styles/sidebar-icon-rail.css';
import Router from './Router';
import { useSessionIdle } from './hooks/useSessionIdle';

const idleMs = Number(process.env.REACT_APP_SESSION_IDLE_MS || 30 * 60 * 1000);

function App() {
  useSessionIdle(idleMs);
  return <Router />;
}

export default App;
